import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Text,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface TenderingCreatedDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const TenderingCreatedDialog: React.FC<TenderingCreatedDialogProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Ny ramavtal skapad!
          </DialogTitle>
          <DialogContent>
            <Text>Innehållet av excel filen finns nu i databasen.</Text>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>OK</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default TenderingCreatedDialog;
